import React, { useState, useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadIndicator from 'devextreme-react/load-indicator';
import { useMsal } from "@azure/msal-react";
import { ThemeContext } from '../../../theme/theme';
import './LoginForm.scss';
import { loginRedirect } from '../../../utils/authUtils.js';
import { Button } from 'devextreme-react';


function getButtonStylingMode(theme) {
  return theme === 'dark' ? 'outlined' : 'contained';
}

export const LoginForm = ({ resetLink, createAccountLink }) => {
  const { instance, accounts } = useMsal();

  const [loading, setLoading] = useState(false);

  const onSubmit = useCallback(
    async () => {
      setLoading(true);
      loginRedirect(instance, accounts);
    },
    [instance, accounts]
  );

  return (
    <div className={'login-form'}>
      <Button 
        type="default"
        disabled={loading}
        text='Weiter'
        onClick={onSubmit}
        width="100%"
        height={50}
        elementAttr={{
          style: {
            fontSize: '18px',
            fontWeight: '600'
          }
        }}
      />
    </div>
  );
};

export const HandleLoginForm = () => {
  const { instance } = useMsal();
  
  // Check if MSAL instance was already initialized in index.js
  console.log(window.location.href);
  // Handle redirect promise before starting React app
  
  instance.handleRedirectPromise().then((tokenResponse) => {
    console.log('MSAL initialized successfully in loginform.js:', tokenResponse);
    if (tokenResponse && tokenResponse.account) {
      console.log('Redirect response received in loginform.js:', tokenResponse);
      instance.setActiveAccount(tokenResponse.account);
    }
    console.log(window.location.href);
  }).catch((error) => {
    console.error('MSAL initialization error:', error);
  });

  return (<div>Anmeldung wird verarbeitet</div>)
}


